import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom>
        Política de Privacidad
      </Typography>
      
      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          1. Información que Recopilamos
        </Typography>
        <Typography paragraph>
          Recopilamos información que usted nos proporciona directamente cuando utiliza nuestros servicios, incluyendo:
        </Typography>
        <ul className="list-disc pl-6 space-y-2">
          <li>Información de contacto (nombre, email, teléfono)</li>
          <li>Información de facturación y pago</li>
          <li>Historial de compras y pedidos</li>
        </ul>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          2. Uso de la Información
        </Typography>
        <Typography paragraph>
          Utilizamos la información recopilada para:
        </Typography>
        <ul className="list-disc pl-6 space-y-2">
          <li>Procesar sus pedidos y transacciones</li>
          <li>Comunicarnos con usted sobre sus pedidos</li>
          <li>Mejorar nuestros servicios</li>
          <li>Enviar información sobre promociones y ofertas</li>
        </ul>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          3. Protección de Datos
        </Typography>
        <Typography paragraph>
          Implementamos medidas de seguridad técnicas y organizativas para proteger sus datos personales contra el acceso no autorizado, la modificación, divulgación o destrucción no autorizada.
        </Typography>
      </Box>

      <Box>
        <Typography variant="h5" gutterBottom>
          4. Sus Derechos
        </Typography>
        <Typography paragraph>
          Usted tiene derecho a:
        </Typography>
        <ul className="list-disc pl-6 space-y-2">
          <li>Acceder a sus datos personales</li>
          <li>Rectificar datos inexactos</li>
          <li>Solicitar la eliminación de sus datos</li>
          <li>Oponerse al procesamiento de sus datos</li>
        </ul>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;